import * as React from "react";
import { TextField, FunctionField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /pro/{proId}/broadcast-lists — suppression :
// DELETE /pro/{proId}/broadcast-lists/{listId}.
export default {
  list: subResourceList({
    parentParam: "proId",
    parentLabel: "ID pro",
    canDelete: true,
    children: [
      <TextField key="name" source="name" label="Nom" />,
      <FunctionField key="count" label="Patients" render={(r) => (r?.patientIds || []).length} />,
      <FrDateField key="createdAt" source="createdAt" label="Créée le" showTime />,
    ],
  }),
};
